import React from 'react';
import { Helmet } from 'react-helmet';
import logo from '../../media/branding/logo.png'
import bg from "../../media/backgrounds/bg-2.png"
import Navbar from '../navigation/Navbar'; // Assuming Navbar component exists
import { useStudentsPage } from '../../features/students/model/useStudentsPage';
import StudentCreateForm from '../../features/students/components/StudentCreateForm';
import StudentCard from '../../features/students/components/StudentCard';
import ArchiveConfirmModal from '../../features/students/components/ArchiveConfirmModal';
const StudentsPage = () => {
    const {
        user,
        students,
        archivedStudents,
        formData,
        loading,
        copiedField,
        showArchiveModal,
        studentToArchive,
        passwordInputs,
        passwordLoadingId,
        actions
    } = useStudentsPage();

    const {
        createStudent,
        deleteStudent,
        archiveStudent,
        confirmArchive,
        unarchiveStudent,
        changePassword,
        copyToClipboard,
        updateField,
        updatePasswordInput,
        setShowArchiveModal
    } = actions;

    if (user?.role === 'student') {
        return <h1 className="access-denied">Вы не имеете доступ к этой странице.</h1>;
    }

    return (
        <div className="students-page">
            <Helmet>
                <title>Страница учениц</title>
                <link rel="shortcut icon" href={logo} />
            </Helmet>

            <main className="students-container">
                <StudentCreateForm
                    formData={formData}
                    loading={loading}
                    onUpdateField={updateField}
                    onCreate={createStudent}
                />

                {/* Active Students List */}
                <section className="students-list-section">
                    <h2>Список учениц</h2>

                    {students.length === 0 ? (
                        <div className="empty-state">
                            <h3>Ученицы не найдены</h3>
                        </div>
                    ) : (
                        <div className="students-grid">
                            {students.map(student => (
                                <StudentCard
                                    key={student.public_key}
                                    student={student}
                                    copiedField={copiedField}
                                    isAdmin={user?.role === 'admin'}
                                    passwordInput={passwordInputs[student.public_key]}
                                    isPasswordLoading={passwordLoadingId === student.public_key}
                                    onOpenDetails={(studentId) => window.open(`/profile/${studentId}`)}
                                    onCopy={copyToClipboard}
                                    onArchiveToggle={archiveStudent}
                                    onDelete={deleteStudent}
                                    onPasswordInputChange={updatePasswordInput}
                                    onPasswordChange={changePassword}
                                />
                            ))}
                        </div>
                    )}
                </section>

                {/* Archived Students List */}
                {archivedStudents.length > 0 && (
                    <section className="archived-students-section">
                        <h2 className="archived-title">Архивные ученицы</h2>
                        <div className="students-grid archived-grid">
                            {archivedStudents.map(student => (
                                <StudentCard
                                    key={student.public_key}
                                    student={student}
                                    isArchived={true}
                                    copiedField={copiedField}
                                    isAdmin={user?.role === 'admin'}
                                    passwordInput={passwordInputs[student.public_key]}
                                    isPasswordLoading={passwordLoadingId === student.public_key}
                                    onOpenDetails={(studentId) => window.open(`/profile/${studentId}`)}
                                    onCopy={copyToClipboard}
                                    onArchiveToggle={unarchiveStudent}
                                    onDelete={deleteStudent}
                                    onPasswordInputChange={updatePasswordInput}
                                    onPasswordChange={changePassword}
                                />
                            ))}
                        </div>
                    </section>
                )}
            </main>

            <ArchiveConfirmModal
                isOpen={showArchiveModal}
                studentName={studentToArchive?.name}
                onCancel={() => setShowArchiveModal(false)}
                onConfirm={confirmArchive}
            />

            <Navbar usertype={user?.role} fixedT={user?.fixed_trainer} />

            <style jsx>{`
        body, html {
            background-image: url(${bg});
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-attachment: fixed;
        }
        
        .students-page {
          min-height: 100vh;
          padding: 20px;
          max-width: 900px;
          margin: 0 auto;
        }

        .students-container {
          display: grid;
          gap: 40px;
        }

        .create-student-section {
          background: white;
          padding: 30px;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .student-form {
          max-width: 600px;
          margin: 0 auto;
        }

        .student-form h2 {
          text-align: center;
          margin-bottom: 25px;
          color: #333;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 15px;
          margin-bottom: 20px;
        }

        .form-input,
        .form-textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 14px;
          box-sizing: border-box;
        }

        .form-textarea {
          resize: vertical;
          min-height: 80px;
          margin-bottom: 15px;
        }

        .btn-primary {
          background: #007bff;
          color: white;
          padding: 12px 30px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 16px;
          width: 100%;
        }

        .btn-primary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .students-list-section h2 {
          margin-bottom: 20px;
          color: #333;
        }

        .archived-students-section {
          margin-top: 30px;
          padding-top: 30px;
          border-top: 2px solid #e9ecef;
        }

        .archived-title {
          color: #6c757d;
          margin-bottom: 20px;
          font-size: 1.5rem;
        }

        .students-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 20px;
        }

        .archived-grid {
          opacity: 0.8;
        }

        .student-card {
          background: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          transition: transform 0.2s;
          position: relative;
        }

        .student-card:hover {
          transform: translateY(-2px);
        }

        .archived-card {
          background: #f8f9fa;
          border-left: 4px solid #6c757d;
        }

        .student-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 15px;
        }

        .student-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #e9ecef;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6c757d;
        }

        .archived-avatar {
          background: #dee2e6;
          color: #6c757d;
        }

        .student-info h3 {
          margin: 0;
          color: #333;
        }

        .archived-card .student-info h3 {
          color: #6c757d;
        }

        .student-phone {
          margin: 5px 0 0 0;
          color: #666;
          font-size: 14px;
        }

        .archived-badge {
          background: #6c757d;
          color: white;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          margin-top: 5px;
          display: inline-block;
        }

        .student-credentials {
          margin-bottom: 15px;
        }

        .credential-field {
          padding: 8px;
          margin: 5px 0;
          background: #f8f9fa;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.2s;
          font-size: 14px;
        }

        .credential-field:hover {
          background: #e9ecef;
        }

        .credential-field.copied {
          background: #d4edda;
        }

        .copied-badge {
          color: #155724;
          font-size: 12px;
          margin-left: 10px;
          font-weight: bold;
        }

        .student-actions {
          display: flex;
          gap: 10px;
        }

        .password-change-box {
          margin-top: 12px;
          display: flex;
          gap: 8px;
        }

        .password-input {
          flex: 1;
          padding: 8px 10px;
          border: 1px solid #ced4da;
          border-radius: 4px;
          font-size: 14px;
          min-width: 0;
        }

        .btn-password-change {
          background: #198754;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 12px;
          cursor: pointer;
          font-size: 14px;
          white-space: nowrap;
        }

        .btn-password-change:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .btn-secondary,
        .btn-danger,
        .btn-archive {
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          flex: 1;
        }

        .btn-secondary {
          background: #6c757d;
          color: white;
        }

        .btn-archive {
          background: #ffc107;
          color: #212529;
        }

        .btn-danger {
          background: #dc3545;
          color: white;
        }

        .access-denied,
        .empty-state {
          text-align: center;
          padding: 40px;
          color: #6c757d;
        }

        .empty-state h3 {
          margin: 0;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          max-width: 400px;
          width: 90%;
          text-align: center;
        }

        .modal-content h3 {
          margin: 0 0 15px 0;
          color: #333;
        }

        .modal-content p {
          margin: 0 0 20px 0;
          color: #666;
          line-height: 1.5;
        }

        .modal-actions {
          display: flex;
          gap: 10px;
          justify-content: center;
        }

        .modal-actions button {
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          min-width: 100px;
        }

        @media (max-width: 768px) {
          .students-page {
            padding: 10px;
          }
          
          .create-student-section {
            padding: 20px;
          }
          
          .form-grid {
            grid-template-columns: 1fr;
          }
          
          .students-grid {
            grid-template-columns: 1fr;
          }
          
          .student-actions {
            flex-direction: column;
          }

          .password-change-box {
            flex-direction: column;
          }
          
          .modal-actions {
            flex-direction: column;
          }
        }
      `}</style>
        </div>
    );
};

export default StudentsPage;